import { useNavigate } from 'react-router-dom';

const POSTER =
  'https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=2000&q=60';
const VIDEO = 'https://videos.pexels.com/video-files/3403385/3403385-uhd_2560_1440_24fps.mp4';

export default function CTAStrip() {
  const navigate = useNavigate();

  return (
    <section id="contact" className="relative overflow-hidden" style={{ minHeight: '88vh' }}>
      <div className="absolute inset-0 z-0 video-light-tint">
        <video
          autoPlay
          loop
          muted
          playsInline
          poster={POSTER}
          className="absolute inset-0 w-full h-full object-cover ken-burns"
        >
          <source src={VIDEO} type="video/mp4" />
        </video>
      </div>

      <div className="pointer-events-none absolute inset-0 flex items-center justify-center z-0">
        <div className="orbit w-[800px] h-[800px] absolute float-y"></div>
        <div className="orbit w-[1200px] h-[1200px] absolute"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-36 pb-28 text-center flex flex-col items-center">
        <div className="eyebrow reveal">Want More Leads?</div>
        <h2 className="mt-6 h-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em] max-w-3xl reveal">
          Start With a<br />
          <span style={{ color: '#0D9488' }}>Free AI Check.</span>
        </h2>
        <p className="mt-7 max-w-xl text-base md:text-lg text-slate-600 font-body font-light leading-relaxed reveal">
          We will show what is broken and what to fix first — no jargon, no pressure, just the leaks
          and the plan.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center gap-4 reveal">
          <button
            onClick={() => navigate('/audit')}
            className="fdme-cta inline-flex items-center gap-2 px-7 py-3.5 text-base"
          >
            Get My Free AI Check <i className="ri-arrow-right-up-line"></i>
          </button>
          <a
            href="tel:9542964896"
            className="glass-strong inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-base text-slate-800 font-body font-semibold"
          >
            <i className="ri-phone-line text-teal-500"></i> (954) 296-4896
          </a>
        </div>
      </div>
    </section>
  );
}
